import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=20e7b72e&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerDetails.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CustomerDetails.vue?vue&type=style&index=2&id=20e7b72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7b72e",
  null
  
)

export default component.exports